<template>
  <div class="Sandbox">
    <h1 class="mb-30">Pagination Test View</h1>

    <div class="Sandbox__pagination">
      <input
        v-model.trim.number="pagination.count"
        class="mb-30"
        data-cy="sandbox-pagination-count-input"
      >

      <div
        v-for="(item, index) in displayedPaginationData"
        :key="index"
        class="Sandbox__test-item mb-20"
      >
        <label
          class="Sandbox__test-item-label"
          :data-cy="`pagination-test-item-${index}`"
        >
          {{ item.name }}
        </label>
      </div>

      <base-pagination
        @paginate="paginate"
        class="mt-30"
        :item-count="pagination.count"
        :page="pagination.page"
        :request-limit="pagination.requestLimit"
      />
    </div>

    <div data-cy="sandbox-base-toggle">
      <base-button
        @click="updateToggleActiveOption"
        class="bg-light fc-white"
        data-cy="sandbox-base-toggle-update-active-option-btn"
      >
        Update active option
      </base-button>
      <base-button
        @click="updateToggleOptions"
        class="bg-light fc-white"
        data-cy="sandbox-base-toggle-update-options-btn"
      >
        Update toggle's options
      </base-button>
      <base-button
        @click="updateToggleLabel"
        class="bg-light fc-white"
        data-cy="sandbox-base-toggle-update-label-btn"
      >
        Update toggle's label
      </base-button>
      <base-button
        @click="updateToggleDisabled"
        class="bg-light fc-white"
        data-cy="sandbox-base-toggle-update-disabled-btn"
      >
        Update toggle's disabled
      </base-button>

      <label data-cy="sandbox-base-toggle-emitted-value">{{ baseToggle.emitted }}</label>

      <base-toggle
        @toggle="baseToggle.activeOption = $event; baseToggle.emitted = $event"
        :active-option="baseToggle.activeOption"
        data-cy="sandbox-base-toggle-toggle"
        :disabled="baseToggle.disabled"
        :label="baseToggle.label"
        :toggles="baseToggle.options"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len */
/* eslint-disable quotes */
import BaseButton from '../../components/base-button.vue'
import BasePagination from '../../components/base-pagination.vue'
import BaseToggle from '../../components/base-toggle.vue'


export default {
  name: 'Sandbox',

  components: {
    BaseButton,
    BasePagination,
    BaseToggle,
  },

  props: {
  },

  data () {
    return {
      baseToggle: {
        activeOption: 'b',
        disabled: false,
        emitted: null,
        label: null,
        options: ['A', 'B', 'C'],
      },
      pagination: {
        count: this.$route.query.count || 0,
        page: this.$route.query.page || 1,
        requestLimit: 5
      },
    }
  },

  watch: {
    // eslint-disable-next-line func-names
    'pagination.count': function () {
      this.$set(this.pagination, 'page', 1)
    },
  },

  computed: {
    displayedPaginationData () {
      const offset = (this.pagination.page - 1) * this.pagination.requestLimit
      return this.fakePaginationData.slice(offset, offset + this.pagination.requestLimit)
    },

    fakePaginationData () {
      const data = []
      for (let i = 0; i < this.pagination.count; i++) {
        data.push({
          name: `item ${i + 1}`
        })
      }
      return data
    },
  },

  methods: {
    paginate (page = null) {
      this.$set(this.pagination, 'page', page)
    },

    updateToggleDisabled () {
      this.$set(this.baseToggle, 'disabled', !this.baseToggle.disabled)
    },

    updateToggleLabel () {
      this.$set(this.baseToggle, 'label', 'Mother fucking labellllllllll')
    },

    updateToggleActiveOption () {
      const activeOption = () => {
        if (this.baseToggle.options.indexOf(this.baseToggle.activeOption.toUpperCase()) === 0) return this.baseToggle.options[1]
        if (this.baseToggle.options.indexOf(this.baseToggle.activeOption.toUpperCase()) === 1) return this.baseToggle.options[2]
        if (this.baseToggle.options.indexOf(this.baseToggle.activeOption.toUpperCase()) === 2) return this.baseToggle.options[0]
      }
      this.$set(this.baseToggle, 'activeOption', activeOption())
    },

    updateToggleOptions () {
      const options = this.baseToggle.options.includes('A') ? ['D', 'E', 'F'] : ['A', 'B', 'C']
      this.$set(this.baseToggle, 'activeOption', null)
      this.$set(this.baseToggle, 'options', options)
    },
  }

}
</script>

<style lang="sass">
.Sandbox
  width: 100%

  &__test-item
    border: 1px solid black
    padding: 20px
    width: 100%
</style>
